import React, { useEffect, useState } from "react";
import Header from "../layouts/Header";
import CategoryBreadCrumbs from "../components/categoryBreadCrumbs.jsx";
import { Link, useNavigate } from "react-router-dom";
import Filter from "../components/Filter.jsx";
import CategoryCard from "../components/CategoryCard.jsx";
import CategoryTitle from "../components/CategoryTitle.jsx"
import Aboutus from "../../User/components/Aboutus";
import Downloadapp from "../../User/components/Download_app";
import Footer from "../../User/layouts/Footer";
import { Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import about_image from "../assets/icons/about-image.svg";
import WhatsApp from "../../User/components/WhatsApp";
import { useSearchParams } from "react-router-dom";
import instance from "../../Utils/api.js";
import Loading from "../assets/loader.svg";
import { Link as RouterLink } from 'react-router-dom';
import { Link as MuiLink } from '@mui/material';




const Categories = () => {
  const [searchparams] = useSearchParams();

  let filterid = searchparams.get("id");
  let filtername = searchparams.get("name");
  let designtype = searchparams.get("designtype");
  let design_type_name = searchparams.get("design_type_name");
  let design_type = searchparams.get("design_type");
  let CategoryId = searchparams.get("CategoryId");
  let Category = searchparams.get("Category");
  const [checked, setChecked] = useState(null);
  const [checkedSub, setCheckedSub] = useState(null);
  const [data, setdata] = useState();
  const [categories, setCategories] = useState();
  const [subCategories, setSubCategories] = useState();
  const [DesignType, setDesignType] = useState();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [reviews, setReviews] = useState([]);


  const getReviews = async () => {
    try {
      const response = await instance.get('Review/Allreviews')
      setReviews(response.data.reviews)
    } catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    getReviews()
  }, [])

  const filterdata = [
    {
      header: "Category", // Dynamic header text
      filters: categories?.map((data) => ({
        name: data?._id,
        label: data?.category,
        checked: checked?.name === data?._id,
      })),
    },
    {
      header: "SubCategory", // Dynamic header text
      filters: subCategories?.map((data) => ({
        name: data?._id,
        label: data?.subCategory,
        checked: checkedSub?.name === data?._id,
      })),
    },
  ];

  const getcategories = async () => {

    try {
      const categoriesData = await instance.get("/Catalogue/getCategorys");
      const activeCategories = categoriesData?.data?.data?.filter(item => item.status === true);

      setCategories(activeCategories);
    } catch (error) {
      console.log(error);
    }
  };
  // console.log("checked", checked);
  const getsubcategories = async (checked) => {
    // console.log("checked", checked);

    try {
      const subCategoriesData = await instance.get(`/Catalogue/getSubCategory${checked ? `?category=${checked}` : ''}`);
      const activeSubCategories = subCategoriesData?.data?.data?.filter(item => item.status === true);

      setSubCategories(activeSubCategories);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getcategories();
  }, []);
  useEffect(() => {
    getsubcategories(checked?.name);
  }, [checked?.name]);

  const getFilterData = async (data) => {
    try {
      let response;
      if (designtype === true) {
        response = await instance.get(`/Catalogue/getDesign?${data ? data : ""}`);
      } else {
        response = await instance.get(`/Catalogue/getDesignType?${data ? data : ""}`);
      }
      setdata(response?.data?.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (CategoryId && categories?.length) {
      const selectedCategory = categories.find(
        (category) => category._id === CategoryId
      );

      if (selectedCategory) {
        setChecked({
          name: selectedCategory._id,
          label: selectedCategory.category,
        });
        setCheckedSub(null);
      }
    }
  }, [CategoryId, categories]);

  useEffect(() => {
    const getFilterData = async () => {


      const params = {
        category: checked?.name, // Array of selected category IDs
        subCategory: checkedSub?.name, // Array of selected subCategory IDs
        design_type: design_type_name,
        limit: 100,
      };
      // console.log(params);

      try {
        let response;
        if (design_type) {
          response = await instance.get(`/Catalogue/getDesign`, { params });
        } else {
          response = await instance.get(`/Catalogue/getDesignType`, { params });
        }
        setdata(response?.data?.data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    getFilterData();
  }, [checked, checkedSub, categories, subCategories, designtype, design_type_name]);

  // useEffect(() => {
  //   filterid ? getFilterData(`category=${filterid}&limit=100`) : getFilterData();
  // }, [filterid]);


  const getBreadcrumbs = () => {
    const crumbs = [
      <Link
        underline="hover"
        key="catalogue"
        color="inherit"
        href="/catalogue"
        onClick={() => {
          setChecked(null);
          setCheckedSub(null);
        }}
      >
        Catalogue
      </Link>
    ];

    if (checked?.label) {
      if (checkedSub?.label) {
        crumbs.push(
          <MuiLink
            underline="hover"
            key="filtername-link"
            color="inherit"
            component={RouterLink}
            to={`/Categories?id=${checked?.name}&name=${checked?.label}`} // 3. Use the "to" prop instead of "href"
            onClick={() => setCheckedSub(null)}
          >
            {checked?.label}
          </MuiLink>
        );
        if (!design_type) {
          crumbs.push(
            <Typography key="filtername-text" color="text.primary">
              {checkedSub?.label}
            </Typography>
          );
        }
      } else if (!design_type) {
        crumbs.push(
          <Typography key="filtername-text" color="text.primary">
            {checked?.label}
          </Typography>
        );
      }
      if (!checkedSub?.label && design_type) {
        crumbs.push(
          <MuiLink
            underline="hover"
            key="filtername-link"
            color="inherit"
            component={RouterLink}
            to={`/Categories?id=${checked?.name}&name=${checked?.label}`} // 3. Use the "to" prop instead of "href"
          >
            {checked?.label}
          </MuiLink>
        );
      }
    }


    if (design_type) {
      if (checkedSub?.label) {
        crumbs.push(
          <MuiLink
            underline="hover"
            key="filtername-link"
            color="inherit"
            component={RouterLink}
            to={`/Categories?id=${checked?.name}&name=${checked?.label}`} // 3. Use the "to" prop instead of "href"
          >
            {checkedSub?.label}
          </MuiLink>
        );
      }
      crumbs.push(
        <Typography key="design-type-text" color="text.primary">
          {design_type}
        </Typography>
      );
    }

    return crumbs;
  };

  return (
    <React.Fragment>
      <Header />
      <React.Fragment>
        {design_type ? (
          <CategoryBreadCrumbs
            breadcrumbs={getBreadcrumbs()}
            title={`${checked?.label ? checked?.label : "Designs"}`}
            subTitle={`${data?.length} Designs`}
          />
        ) : (
          <CategoryBreadCrumbs
            breadcrumbs={getBreadcrumbs()}
            title={`${checked?.label ? checked?.label : "Design Types"}`}
            subTitle={`${data?.length} Design Types`}
          />)}
      </React.Fragment>
      <section className="filters_component">
        <Grid container spacing={2}>
          <Grid item size={{ xs: 12, sm: 12, md: 3, lg: 2.3 }}>
            <Filter
              filterdata={filterdata}
              defaultChecked={filterid}
              setChecked={(newChecked) => {
                setChecked(newChecked);
                setCheckedSub(null);
                if (newChecked?.name) {
                  navigate(`/Categories?id=${newChecked?.name}&name=${newChecked?.label}`);
                }
              }}
              checked={checked}
              setCheckedSub={(newCheckedSub) => {
                setCheckedSub(newCheckedSub);
                if (checked?.name) {
                  navigate(`/Categories?id=${checked?.name}&name=${checked?.label}`);
                }
              }}
              checkedSub={checkedSub}
            />
          </Grid>
          <Grid item size={{ xs: 12, sm: 12, md: 9, lg: 9.7 }}>
            <div className="categories">
              {design_type ?
                (
                  <CategoryTitle header={"Designs"} />)
                : (
                  <CategoryTitle header={"Design Types"} />
                )
              }
              {loading === true ? (
                <Stack className="loader">
                  <img src={Loading} alt="loader" />
                </Stack>
              ) : (
                <Grid container spacing={2}>
                  {data?.length
                    ? data?.filter((data) => data.status === true).map((data, key) => (
                      <Grid
                        item
                        size={{ xs: 12, sm: 6, md: 6, lg: 3, xl: 3 }}
                        key={key}
                      >
                        <div
                          className="category_cards"
                          onClick={() => {
                            if (design_type) {
                              navigate(`/product/${data?._id}?Category=${checked?.label}&CategoryId=${checked?.name}&subCategoryId=${checkedSub?.name}&subCategory=${checkedSub?.label}&design_type_id=${design_type_name}&design_type=${design_type}`);
                            } else {
                              navigate(`/Categories?id=${checkedSub?.name}&name=${checkedSub?.label}&design_type_name=${data?._id}&design_type=${data?.design_type}`);
                              // setDesignType(data?._id); // This will update the design type after navigation
                            }
                          }}
                        >
                          <CategoryCard
                            image={design_type ? data?.picture[0] : data?.picture}
                            title={design_type ? data.name : data?.design_type}
                          />
                        </div>
                      </Grid>
                    ))
                    : "No Designs Found"}
                </Grid>
              )}
            </div>
          </Grid>
        </Grid>
      </section >
      <React.Fragment>
        <Aboutus data={reviews} />
      </React.Fragment>
      <React.Fragment>
        <Downloadapp />
      </React.Fragment>
      <React.Fragment>
        <Footer />
      </React.Fragment>
      <WhatsApp />
    </React.Fragment >
  );
};

export default Categories;
